<template>
  <ul class="indoorEnvironmentAlarm"
    v-loading="$store.state.user.loadingState">
    <template v-if="list.length">
      <li v-for="(v, i) in list"
        :key="i">
        <div class="describeWrap">
          <h5>{{ v.deviceName }}</h5>
          <p style="margin: 10px 0">地点：{{ v.location }}</p>
          <p>告警原因：{{ v.type }}</p>
          <span style="margin-top: 10px">{{ v.defTime }}</span>
        </div>
        <div class="operation"
          v-if="!v.toWOrkOrder && judgeAuthority('shebei:alarmManagement:edit')"
          @click="workOrder(v)">
          转工单
        </div>
        <div class="operation"
          v-if="v.toWOrkOrder"
          @click="handleClick(v)">已转工单</div>
      </li>
    </template>
    <template v-else>
      <el-empty description="暂无数据"></el-empty>
    </template>

    <SubmitWorkOrder v-if="dialogVisible"
      :activeItem="activeItem" />
  </ul>
</template>

<script>
import api from "@/api";
import { dateFtt, judgeAuthority } from "@/assets/js/utils";
import SubmitWorkOrder from "@/components/shebeiguanli/baojingguanli/SubmitWorkOrder";
export default {
  components: {
    SubmitWorkOrder,
  },
  data() {
    return {
      list: [],
      dialogVisible: false,
      activeItem: {},
    };
  },
  methods: {
    judgeAuthority,
    async getAlarmsList() {
      this.$store.commit("SET_LOADING", true);
      let res = await api.subsystemIndoorAlarm({
        modular: "环境监测",
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.list = res.data.data;
        this.list.map((v) => {
          v.defTime = v.time
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.time))
            : "";
        });
      }
    },
    workOrder(row) {
      row.alarmSeverity =
        row.level == "CRITICAL"
          ? "高危"
          : row.level == "MAJOR"
          ? "危险"
          : "警告";
      this.activeItem = row;
      this.dialogVisible = true;
    },
    handleClick(row) {
      this.$router.push({
        path: "/worksheets",
        query: { id: row.workOrderId },
      });
    },
  },
  created() {
    this.getAlarmsList();
  },
};
</script>

<style lang="scss" scoped>
.indoorEnvironmentAlarm {
  width: 97%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;
  li {
    padding: 20px 20px 10px 20px;
    border-bottom: 1px dashed #e7e7e7;
    @include setFlexBetween;
    .describeWrap {
      width: 78%;
      h5 {
        color: #333;
        font-size: 15px;
      }
      p {
        color: #666;
      }
      span {
        display: inline-block;
        color: #999;
      }
    }
    .operation {
      width: 20%;
      color: #28cccb;
      text-align: center;
      cursor: pointer;
      border-bottom: 1px solid transparent;
    }
    .operation:hover {
      border-color: #28cccb;
    }
  }
}
</style>